import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MilkEntryView from "./MilkEntryView";
import BillListView from "./BillListView";
import AdvanceView from "./AdvanceView";
import SupplyView from "./SupplyView";
import "./MemberRegister/Main/Dashboard.css";

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState(0);
  const mem_id = localStorage.getItem("user_id");

  return (
    <div className="dashboard-container">
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        variant="fullWidth"
        centered
        textColor="inherit"
        TabIndicatorProps={{ style: { backgroundColor: "#ff9800" } }}
        sx={{
          "& .MuiTab-root": { color: "#bbb", fontWeight: "bold", fontSize: "16px" },
          "& .Mui-selected": { color: "#ff9800" },
        }}
      >
        <Tab label="दूध नोंदी" />
        <Tab label="बिल तपशील" />
        <Tab label="ऍडव्हान्स" />
        <Tab label="पशुखाद्य" />
      </Tabs>

      <TabPanel value={activeTab} index={0}>
        <MilkEntryView mem_id={mem_id} />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <BillListView mem_id={mem_id} />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <AdvanceView mem_id={mem_id} />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <SupplyView mem_id={mem_id} />
      </TabPanel>
    </div>
  );
};

export default Dashboard;
